import { render, staticRenderFns } from "./TgSpecialSearchNews.vue?vue&type=template&id=898b8f36&"
import script from "./TgSpecialSearchNews.vue?vue&type=script&lang=js&"
export * from "./TgSpecialSearchNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports